import React from 'react';
import _ from 'lodash';

import TagButton from '../../components/TagButton';

const InterviewDetails = ({
  question, interviews, tags, tracker, className,
}) => {
  const roleMap = _.keyBy(tags.role, 'id');
  const companyMap = _.keyBy(tags.company, 'id');
  const categoryMap = _.keyBy(tags.type, 'id');
  const roles = _(interviews)
    .filter('role') // Filter out interviews where role is null
    .countBy('role') // Count the occurrences of each role
    .map((count, role) => ({
      ...roleMap[role],
      count,
    }))
    .value();
  const companies = _(interviews)
    .filter('company') // Filter out interviews where company is null
    .countBy('company') // Count the occurrences of each company
    .map((count, company) => ({
      ...companyMap[company],
      count,
    }))
    .orderBy('count', 'desc')
    .value();
  const categories = question?.category ? question.category.map((c) => categoryMap[c]) : [];

  return (
    <div className={className}>
      <div className="flex flex-col py-4 gap-y-3">
        <h3 className="text-xl font-semibold mb-1">
          Interview Details
        </h3>
        {!_.isEmpty(roles) && (
          <div className="flex">
            <div className="w-28 flex-shrink-0 font-semibold text-base">Roles</div>
            <div className="flex-grow overflow-auto scrollbar-hidden">
              {roles.map((r) => r?.id && r?.type && r?.name && (
                <TagButton
                  key={r?.id}
                  tag={r}
                  className="align-middle"
                  onClick={() => tracker.questionClickTag({
                    tag: r.id,
                    type: r.type,
                    question: question.id,
                  })}
                />
              ))}
            </div>
          </div>
        )}
        {!_.isEmpty(companies) && (
          <div className="flex">
            <div className="w-28 flex-shrink-0 font-semibold text-base">Companies</div>
            <div className="flex-grow overflow-auto scrollbar-hidden">
              {companies.map((c) => (
                c?.id && c?.type && c?.name && (
                <TagButton
                  key={c?.id}
                  tag={c}
                  count={c?.count}
                  className="align-middle"
                  onClick={() => tracker.questionClickTag({
                    tag: c.id,
                    type: c.type,
                    question: question.id,
                  })}
                />
                )))}
            </div>
          </div>
        )}
        {!_.isEmpty(categories) && (
          <div className="flex">
            <div className="w-28 flex-shrink-0 font-semibold text-base">
              <span>Categories</span>
            </div>
            <div className="flex-grow overflow-auto scrollbar-hidden">
              {categories.map((s) => (
                <TagButton
                  key={s?.id}
                  tag={s}
                  className="align-middle"
                  onClick={() => tracker.questionClickTag({
                    tag: s.id,
                    type: s.type,
                    question: question.id,
                  })}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default InterviewDetails;
